export interface CalendarPayment {
  firstPaymentDate: string;
  cycleFrequency: 'monthly' | 'quarterly' | 'semiannual' | 'annual';
}

export const calendarMzic2: CalendarPayment = {
  firstPaymentDate: '2025-10-28',
  cycleFrequency: 'semiannual',
};
